import { ANCHOR_NAVIGATION_QUERY_PARAM, EMBEDDED_FRAME_ID_QUERY_PARAM, EMBEDDED_IN_APP_NAME_DATA_ATTRIBUTE, TEST_EMBEDDED_VERSION_OUTSIDE_IFRAME } from './constants';
export const getIsTestingEmbeddedVersionOutsideIframe = () => {
  const url = new URL(window.location.href);
  return url.searchParams.get(TEST_EMBEDDED_VERSION_OUTSIDE_IFRAME) === 'true';
};
export const getEmbeddedFrameIdFromUrl = () => {
  const url = new URL(window.location.href);
  return url.searchParams.get(EMBEDDED_FRAME_ID_QUERY_PARAM) || undefined;
};
const getIsInSameOriginIframe = () => {
  try {
    return window.top !== null && window.self !== window.top && window.top.location.origin === window.self.location.origin;
  } catch (e) {
    return !!getEmbeddedFrameIdFromUrl();
  }
};
export const getIsInIframe = () => {
  return getIsTestingEmbeddedVersionOutsideIframe() || getIsInSameOriginIframe();
};
export const getAnchorFromUrl = () => {
  const url = new URL(window.location.href);
  return url.searchParams.get(ANCHOR_NAVIGATION_QUERY_PARAM);
};
export const getAnchorTestId = anchor => `embedded-studio-anchor-${anchor || 'default'}`;
export const removeAnchorFromUrl = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete(ANCHOR_NAVIGATION_QUERY_PARAM);
  window.history.replaceState({}, '', `${window.location.pathname}${url.search}`);
};
export const appendQueryParam = (url, param, value) => {
  const urlObj = new URL(url);
  urlObj.searchParams.set(param, value);
  return urlObj.toString();
};
export const appendAnchorToUrl = (url, anchor) => {
  return appendQueryParam(url, ANCHOR_NAVIGATION_QUERY_PARAM, anchor);
};
export const getEmbeddedInAppNameFromDOM = () => {
  const elementWithAppName = document.querySelector('[data-application-name]');
  return elementWithAppName === null || elementWithAppName === void 0 ? void 0 : elementWithAppName.dataset[EMBEDDED_IN_APP_NAME_DATA_ATTRIBUTE];
};